import { useQuery } from '@tanstack/vue-query'
import { apiClient } from '@/apis/instances/api-client'
import { checkApiResponse } from '@/apis/instances/check-api-response'
import { ApiV2ReservationdatenoteElFindParams } from '@/apis/swaggers/v2/v2-swagger'
import { QUERY_KEY } from '@/apis/swaggers/swagger-docs'
import { QueryComposableParams } from '@/types/query-options'
import { resolveMaybeGetter } from '@/util/resolve-maybe-getter'

type QueryParams = QueryComposableParams<ApiV2ReservationdatenoteElFindParams, unknown>

const fetchReservationDateNoteList = async (params: ApiV2ReservationdatenoteElFindParams) => {
  const { data } = await apiClient.v2.apiV2ReservationdatenoteElFind(params);
  return checkApiResponse(data);
}

export const v2ReservationDateNoteKeys = {
  all: [QUERY_KEY.v2apiV2ReservationdatenoteElFind] as const,
  list: (params: ApiV2ReservationdatenoteElFindParams) => [...v2ReservationDateNoteKeys.all, params] as const,
}

/** 명령형(await) 호출용 쿼리 정의 — 워처/이벤트 핸들러 등 순차 흐름에서
 * `queryClient.fetchQuery(v2ReservationDateNoteFindQueryOptions(params))` 로 사용한다 (캐시 경유는 동일) */
export const v2ReservationDateNoteFindQueryOptions = (params: ApiV2ReservationdatenoteElFindParams) => ({
  queryKey: v2ReservationDateNoteKeys.list(params),
  queryFn: () => fetchReservationDateNoteList(params),
})

export const useV2ReservationDateNoteFindQuery = ({ params, options }: QueryParams) => {
  return useQuery(() => ({
    queryKey: v2ReservationDateNoteKeys.list(resolveMaybeGetter(params)),
    queryFn: () => fetchReservationDateNoteList(resolveMaybeGetter(params)),
    ...resolveMaybeGetter(options ?? {}),
  }))
}
